import { RoleEnums } from '../enums/user.enum';
import { PermissionsScopes } from '../interfaces/account.interface';

export interface MenuI {
  icon: string;
  route: string;
  title: string;
  routeExact: boolean;
  scope?: PermissionsScopes;
  allowedRoles?: RoleEnums[];
}
export const MenuItems: MenuI[] = [
  {
    icon: 'home-outline',
    route: '/dashboard',
    title: 'home',
    routeExact: true,
  },
  {
    icon: 'people-outline',
    route: '/members',
    title: 'Members',
    routeExact: false,
    scope: 'payer',
  },
  {
    icon: 'card-outline',
    route: '/transactions',
    title: 'Transactions',
    routeExact: false,
    scope: 'transaction',
  },
];

export const SettlementRoutes = [
  {
    icon: 'home-outline',
    route: '/settlement',
    title: 'Overview',
    routeExact: true,
  },
  {
    icon: 'albums-outline',
    route: '/settlement/accounts',
    title: 'Settlement Accounts',
    routeExact: true,
  },
  {
    icon: 'analytics-outline',
    route: '/settlement/analytics',
    title: 'Analytics',
    routeExact: true,
  },
  {
    icon: 'card-outline',
    route: '/settlement/payouts',
    title: 'Payouts',
    routeExact: true,
  },
];

export const UserRoutes = [
  {
    icon: 'home-outline',
    route: '/payers',
    title: 'Home',
    routeExact: true,
  },
  {
    icon: 'albums-outline',
    route: '/payers/groups',
    title: 'Payer Sub-Groups',
    routeExact: true,
  },
];

export const TrxnRoutes = [
  {
    icon: 'home-outline',
    route: '/transactions',
    title: 'Invoice',
    routeExact: true,
  },
  {
    icon: 'arrow-down-outline',
    route: '/transactions/transfers',
    title: 'Transfer',
    routeExact: true,
  },

  {
    icon: 'wallet-outline',
    route: '/transactions/payouts',
    title: 'Payouts',
    routeExact: true,
  },
];

export const AnalyticsRoutes = [
  {
    icon: 'home-outline',
    route: '/analytics',
    title: 'Revenue',
    routeExact: true,
  },
  {
    icon: 'arrow-down-outline',
    route: '/analytics/transactions',
    title: 'Transactions',
    routeExact: true,
  },
  {
    icon: 'arrow-down-outline',
    route: '/analytics/settlement',
    title: 'Settlement & Payouts',
    routeExact: true,
  },
  {
    icon: 'arrow-down-outline',
    route: '/analytics/admin',
    title: 'Admin Activity',
    routeExact: true,
  },
];
